import React from 'react';
import ToolLayout from '../components/ToolLayout';
import { Trophy } from 'lucide-react';

/**
 * Standalone Valuables Inventory tool.
 * List high-value items for insurance documentation; export to add to your binder.
 */
const ValuablesTool = () => {
  return (
    <ToolLayout
      title="Valuables Inventory"
      description="List high-value items for insurance documentation. Export for your preparedness binder."
      icon={Trophy}
      guide={{
        intro: 'Document high-value items for insurance claims after a disaster.',
        steps: [
          'Add items with name, category, and estimated value.',
          'Note the location or add photo references.',
          'Export for your binder.',
        ],
      }}
    >
      <div className="max-w-2xl mx-auto space-y-6">
        <p className="text-muted-foreground">
          Keep an inventory of valuables with estimated values and locations for insurance and recovery after a disaster.
        </p>
        <p className="text-sm text-muted-foreground">
          Full valuables list and Export coming soon.
        </p>
      </div>
    </ToolLayout>
  );
};

export default ValuablesTool;
